import axios from "../axios";

const fetchPlaylistById = (id) => axios.get(`playlist/${id}`);

const updatePlaylist = (id, payload) => axios.post(`playlist/${id}`, payload);

const deletePlaylist = (id) => axios.delete(`playlist/${id}`);

const addPlaylist = (payload) => axios.post("/playlist/create-new", payload);

const addImage = (playlistId, payload) =>
  axios.post(`playlists/${playlistId}/upload-image`, payload);

//! confirm this
const ignoreSong = (playlistId, songId, payload) =>
  axios.post(
    `/v1/customer/playlists/${playlistId}/songs/${songId}/ignore`,
    payload
  );

const downloadPlaylist = (playlistId) =>
  axios.get(`/playlist/download/${playlistId}`);

export const playlistServices = {
  fetchPlaylistById,
  updatePlaylist,
  deletePlaylist,
  addPlaylist,
  ignoreSong,
  addImage,
  downloadPlaylist,
};
